






































import { Vue, Component } from "vue-property-decorator";
import ItemsCarousel from "@/components/Customizer/Customization/ItemsCarousel.vue";
import { customizationStore, httpStore, routingStore, currentUserStore } from "@/store/typed";
import { CART_SLUG,STORE_URL } from "@/constants";
import { ProductCustomizationMixinTags } from "@/mixins/http/ProductCustomizationMixin";
import { ProductMixinTags } from "@/mixins/http/ProductMixin";
import Spinner from "@/components/Common/Spinner.vue";
import { addToCart } from "@/services/woocommerceService";
import { easync } from "@/helpers/http";
import { showError } from "@/helpers/Toast";
import DotLoader from "@/components/Common/DotLoader.vue";

@Component({
  components: {
    ItemsCarousel,
    Spinner,
    DotLoader
  },
})
export default class Recap extends Vue {

  private addingToCart = false;
  private goingToCart = false;

  created() {
    customizationStore._setProduct({
      id: this.productId,
      reloadCustomization: true,
    });
  }

  get productId() {
    return customizationStore.product.externalId;
  }

  get productCustomization() {
    return customizationStore.productCustomization;
  }

  get productCustomizationLoading() {
    return (
      httpStore.status[ProductCustomizationMixinTags.Create]?.loading ||
      httpStore.status[ProductMixinTags.Show + this.productId]?.loading
    );
  }

  private goToEditor() {
    routingStore.goToConfigurator();
  }

  get editMode() {
    return customizationStore.editMode;
  }

  async addToCart() {
    this.addingToCart = true;
    const [data, error] = await easync(
      addToCart(this.productId, 1, this.productCustomization?.uuid)
    );
    this.addingToCart = false;
   
    if (data) {
      this.goToCart();
    } else {
      
      console.error("Could not add to the cart", error);
    }
  }

  async goToCart() {
    this.goingToCart = true;
    const lang = currentUserStore.lang;
    localStorage.removeItem("ilmyo_customizer");
    window.location.assign(`${STORE_URL}/${lang}/${CART_SLUG}`);
  }
}
